import TableHead, { TableHeadProps } from '@material-ui/core/TableHead';
import * as React from 'react';
interface Props extends TableHeadProps {}

export const AppTableHead = (props: Props) => {
  return <TableHead {...props}></TableHead>;
};
